import { PagingDto } from '../common/paging.dto'

export class FindInvoiceDto extends PagingDto {
  public searchText: string
  public status: string
}
